import React, { PureComponent, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../shared/header';
import Footer from '../shared/footer';
import { FetchBookingMeta } from '../../actions/booking';

class GenericError extends PureComponent {

  constructor(props){
    super(props)
    this.state = {
      iscyoa:false
    }
  }

  componentDidMount(){
    window.scrollTo(0, 0);

    const { match: {params:{ bookingguid } }, history, FetchBookingMeta, currency } = this.props;

    //Check if booking is CYOA
    //Redirect if booking reference parameter does not exist
    if(bookingguid === undefined){
      history.push('/');
    }else{
      if(Object.keys(currency).length !== 0){
        FetchBookingMeta(bookingguid).then(data => {
          if(data !== undefined) this.setState({iscyoa: data.is_cyoa});
        });
      }
    }
  }

  renderPaymentErrorMsg(msg){
    switch(msg){
      case "CANCEL":
        return this.props.errorMessages["PAYMENT_CANCEL"];
      case 'DECLINE':
        return this.props.errorMessages["PAYMENT_DECLINE"];
      default:
        return this.props.errorMessages["PAYMENT_ERROR"];
    }
  }

  renderErrorSubMsg(guid, msg){
    switch (msg) {
      case "CANCEL":
      case "DECLINE":
        const isCYOA = (this.state.iscyoa) ? "/cyoa" : "";
        return <p>Please return to <Link to= {`/paymentdetails/${guid}${isCYOA}`} className="busabout--cta--link orange">payments</Link> and try again</p>
      default:
        return <p>Find an <a href="https://www.busabout.com/trips" className="busabout--cta--link orange">interesting Adventure.</a></p>
    }
  }

  render(){

    const { errorType, errorMessages, match: {params:{ bookingguid, bookingstatus } } } = this.props;

    return (
      <Fragment>
      <Header />
      <div className="genericError">
        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
            <div className="row">
              <div className="column small-12" style={{ display: (errorType === 'paymenterror') ? "block": "none"}}>
                <p className="bold">
                  {this.renderPaymentErrorMsg(bookingstatus)}
                </p>
                {this.renderErrorSubMsg(bookingguid, bookingstatus)}
              </div>

              <div className="column small-12" style={{ display: (errorType === '404') ? "block": "none"}}>
                  <h4>404 page is not found</h4>
                  <p>{errorMessages["GENERIC"]}</p>
                  <p>Find an <a href="https://www.busabout.com/trips" className="busabout--cta--link orange">interesting Adventure.</a></p>
              </div>

              <div className="column small-12" style={{ display: (errorType === '500') ? "block": "none"}}>
                  <h4>500 Internal server error</h4>
                  <p>{errorMessages["GENERIC"]}</p>
                  <p>Find an <a href="https://www.busabout.com/trips" className="busabout--cta--link orange">interesting Adventure.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
     <Footer />
    </Fragment>
    )
  }
}


function mapStateToProps(state){
  return {
    errorMessages:state.errorMessages,
    currency:state.currency
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchBookingMeta,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericError);



// WEBPACK FOOTER //
// ./src/components/error/genericerror.js